var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "foodListWrap"
  }, [_vm.skuCouponType === 'group' ? _c('div', [_vm.skuDataList.length === 1 ? _c('div', {
    staticClass: "foodVoteList",
    class: _vm.themeClass
  }, [_c('div', {
    staticClass: "foodVoteList-item",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.goPurchase(_vm.skuData.action_url, '1');
      }
    }
  }, [_c('itemCard', {
    staticClass: "itemCard",
    attrs: {
      "item": _vm.skuData,
      "is-car": _vm.isCar,
      "is-house": _vm.isHouse
    }
  })], 1), _c('div', {
    staticClass: "foodVoteList-more-box",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.purchaseMore(_vm.skuData.bottom_url);
      }
    }
  }, [_vm.all_text ? _c('moreCard', {
    attrs: {
      "all_text": _vm.all_text
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm.skuDataList.length > 1 ? _c('div', {
    staticClass: "foodPackageList",
    style: _vm.skuDataList.length > 1 ? '' : 'padding-right: 14px;'
  }, [_c('div', {
    staticClass: "foodPackageList-box"
  }, [_vm._l(_vm.skuData, function (item, i) {
    return _c('div', {
      key: i
    }, [_c('div', {
      staticClass: "foodPackageList-item",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.goPurchase(item.action_url, '1');
        }
      }
    }, [_c('itemCard', {
      staticClass: "itemCard",
      attrs: {
        "item": item,
        "is-car": _vm.isCar,
        "is-house": _vm.isHouse
      }
    })], 1)]);
  }), _c('div', {
    staticClass: "foodPackageList-more-box",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.purchaseMore(_vm.skuData[0].bottom_url);
      }
    }
  }, [_vm.all_text ? _c('moreCard', {
    attrs: {
      "all_text": _vm.all_text
    }
  }) : _vm._e()], 1)], 2)]) : _vm._e()]) : _vm._e(), _vm.skuCouponType === 'normal' ? _c('div', {
    staticClass: "foodCouponList"
  }, [_c('div', {
    staticClass: "foodCouponList-item",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.goPurchase(_vm.skuData.action_url, '1');
      }
    }
  }, [_c('div', {
    class: {
      'foodCouponList-item-img': true
    },
    style: {
      backgroundImage: `url(${_vm.skuData.ext.product_title_icon})`
    }
  }), _vm.skuData.product_name ? _c('div', {
    staticClass: "poi-name"
  }, [_vm._v(" " + _vm._s(_vm.skuData.product_name) + " ")]) : _vm._e(), _c('div', {
    staticClass: "content-list-right",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.goPurchase(_vm.skuData.button_url, '2');
      }
    }
  }, [_c('div', {
    staticClass: "go-purchase"
  }, [_vm._v(_vm._s(_vm.skuData.button_text || '立即领取'))]), _c('div', {
    staticClass: "arrow",
    attrs: {
      "alt": ""
    }
  })])])]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };